
<!-- Breadcrumb -->
<div class="breadcrumb-container">
  <nav class="breadcrumb">
    <span class="breadcrumb-link-color">Dashboard</span>
    <span class="breadcrumb-separator">›</span>
    <a class="breadcrumb-link" routerLink="/request">Request</a>
    <span class="breadcrumb-separator">›</span>
    <span class="breadcrumb-current">{{ requestType }}</span>
  </nav>
</div>

<div class="approve-user">
  <div class="card">

    <!-- Header -->
    <div class="card-header">
      <span class="card-title">Request &mdash; {{ requestType }}</span>
      <span class="card-request-id">Request #{{ requestId }}</span>
    </div>

    <div class="card-body">

      <!-- Stepper (only for Add New User) -->
      @if (formType === 'addUser') {
      <div class="stepper">
        <div class="step step--active">
          <span class="step-circle">1</span>
          <span class="step-label">Approving a Request</span>
        </div>
      </div>
      }

      <!-- Form -->
      @if (formType === 'aoslRequest') {
      <div class="form">

        <div class="form-row">
          <label class="form-label">Type of Request</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.requestType" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Name of Accenture Operation Service Line <span class="required">*</span></label>
          <div class="form-control form-control--lg">
            <input class="form-input" [class.form-input--readonly]="isViewMode"
                   [(ngModel)]="aoslForm.name" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Contract Number</label>
          <div class="form-control form-control--md">
            <input class="form-input" [class.form-input--readonly]="isViewMode"
                   [(ngModel)]="aoslForm.contractNumber" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Master Customer Number</label>
          <div class="form-control form-control--md">
            <input class="form-input" [class.form-input--readonly]="isViewMode"
                   [(ngModel)]="aoslForm.masterCustomerNumber" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Market</label>
          <div class="form-control form-control--sm">
            <div class="select-wrapper">
              <select class="form-select" [(ngModel)]="aoslForm.market" [disabled]="isViewMode">
                @for (m of aoslMarkets; track m) {
                <option [value]="m">{{ m }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Market Unit</label>
          <div class="form-control form-control--sm">
            <div class="select-wrapper">
              <select class="form-select" [(ngModel)]="aoslForm.marketUnit" [disabled]="isViewMode">
                @for (mu of aoslMarketUnits; track mu) {
                <option [value]="mu">{{ mu }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Comments/Summary/Notes/Issue <span class="required">*</span></label>
          <div class="form-control form-control--xl">
            <textarea class="form-input form-textarea" [class.form-input--readonly]="isViewMode"
                      rows="4" [(ngModel)]="aoslForm.comments" [readonly]="isViewMode"></textarea>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Attachment</label>
          <div class="form-control form-control--lg">
            @if (aoslForm.attachments.length > 0) {
              @for (doc of aoslForm.attachments; track doc.fileName) {
                <a class="form-link" href="javascript:void(0)" (click)="downloadDocument(doc)">{{ doc.fileName }}</a>
              }
            } @else {
              <span class="form-no-attachment">No attachments</span>
            }
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.requestedBy" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested Date &amp; Time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.requestedDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Created Date &amp; Time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.createdDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Modified Date &amp; Time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.modifiedDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Created By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.createdBy" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Modified By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="aoslForm.modifiedBy" readonly />
          </div>
        </div>

      </div>
      } @else if (formType !== 'addUser') {
      <div class="form">

        <div class="form-row">
          <label class="form-label">Request ID:</label>
          <div class="form-control form-control--lg">
            <span class="form-link form-link--grey">{{ requestId }}</span>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Review ID <span class="required">*</span><span>:</span></label>
          <div class="form-control form-control--lg">
              <a class="form-link" href="javascript:void(0)" (click)="navigateToReview()">{{ requestDetailsForm.reviewId }}</a>
          </div>
        </div>
        @if(formType === 'revisedTargetDate') {
          <div class="form-row">
            <label class="form-label">Revised Target Publication Date <span class="required">*</span></label>
            <div class="form-control form-control--lg">
              <input class="form-input form-input--readonly" [value]="requestDetailsForm.revisedTargetPublicationDate" readonly />
               <!-- {{requestDetailsForm.revisedTargetPublicationDate}} -->
            </div>
          </div>
        }

        <div class="form-row">
          <label class="form-label">{{ requestType === 'Review Cancellation' ? 'Comments/Reason' : 'Reason for not applicable' }} <span class="required">*</span><span>:</span></label>
          <div class="form-control form-control--xl">
            <textarea class="form-input form-textarea form-input--readonly" rows="4" [value]="requestDetailsForm.reason" readonly></textarea>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Attachment:</label>
          <div class="form-control form-control--lg">
            @if (requestDetailsForm.attachments.length > 0) {
              @for (doc of requestDetailsForm.attachments; track doc.fileName) {
                <a class="form-link" href="javascript:void(0)" (click)="downloadDocument(doc)">{{ doc.fileName }}</a>
              }
            } @else {
              <span class="form-no-attachment">No attachments</span>
            }
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.requestedBy" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested Date &amp; time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.requestedDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Created Date &amp; time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.createdDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Modified Date &amp; time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.modifiedDateTime" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Created By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.createdBy" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Modified By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestDetailsForm.modifiedBy" readonly />
          </div>
        </div>
      </div>
      } @else if (formType === 'addUser') {
      <div class="form">

        <div class="form-row">
          <label class="form-label">Request Type</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="addNewUserForm.requestType" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Email / Enterprise ID <span class="required">*</span></label>
          <div class="form-control form-control--md">
            <input class="form-input" type="email" [(ngModel)]="addNewUserForm.email" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">First Name <span class="required">*</span></label>
          <div class="form-control form-control--md">
            <input class="form-input" [(ngModel)]="addNewUserForm.firstName" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Last Name <span class="required">*</span></label>
          <div class="form-control form-control--md">
            <input class="form-input" [(ngModel)]="addNewUserForm.lastName" [readonly]="isViewMode" />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">R&amp;C Function / Designation <span class="required">*</span></label>
          <div class="form-control form-control--sm">
            <input class="form-input form-input--readonly" [value]="addNewUserForm.rcFunction" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Country <span class="required">*</span></label>
          <div class="form-control form-control--sm">
            <div class="select-wrapper">
              <select class="form-select" [(ngModel)]="addNewUserForm.country" [disabled]="true">
                @for (c of countries; track c) {
                <option [value]="c">{{ c }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Work Location <span class="required">*</span></label>
          <div class="form-control form-control--sm">
            <div class="select-wrapper">
              <select class="form-select" [(ngModel)]="addNewUserForm.workLocation" [disabled]="true">
                @for (loc of workLocations; track loc) {
                <option [value]="loc">{{ loc }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Expiration On</label>
          <div class="form-control form-control--sm">
            <div class="form-input rve-date-picker-wrap rve-date-picker-wrap--disabled">
              <span class="rc-date-display">{{ formatDateDisplay(addNewUserForm.expirationOn) || 'DD-MMM-YYYY' }}</span>
              <input #rvePicker_expiry type="date" class="rc-date-input-hidden"
                     [(ngModel)]="addNewUserForm.expirationOn"
                     [readOnly]="isViewMode" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested By</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestedBy" readonly />
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Requested Date and Time</label>
          <div class="form-control form-control--lg">
            <input class="form-input form-input--readonly" [value]="requestedDate" readonly />
          </div>
        </div>

      </div>
      } @else {
      <div class="form">
        <p class="form-placeholder">
          The <b>{{ requestType }}</b> request form is not available yet.
        </p>
      </div>
      }

      <!-- Actions -->
      <div class="actions">
        @if (isViewMode) {
        <button type="button" class="btn btn-cancel-view" (click)="onCancel()">Cancel</button>
        } @else {
        <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
        @if (!isSelfReviewCancellationRequest && !isApprovalBlockedForCurrentUser) {
        <!-- Generated by GitHub Copilot - Oct-07-2026 -->
        <button type="button" class="btn btn-reject" (click)="onReject()"
          [disabled]="isRequestCompleted">Reject</button>
        <button type="button" class="btn btn-approve" (click)="onApprove()"
          [disabled]="isRequestCompleted">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          {{ formType === 'aoslRequest' ? 'Approve and Create SL' : formType === 'addUser' ? 'Approve and Create User' : 'Approve' }}
        </button>
        }
        }
      </div>
      

    </div>
  </div>
</div>

<!-- Navigation loader -->
@if (isNavigatingToReview) {
<div class="rve-overlay">
  <div class="rve-spinner"></div>
</div>
}

<!-- Approve / Reject loader -->
@if (isLoading) {
<div class="rve-overlay">
  <div class="rve-spinner"></div>
</div>
}

<!-- ─── Confirm Request Approval Popup ─── -->
@if (showApproveModal ) {
<div class="approve-popup-overlay" (click)="closeApproveModal()">
  <div class="approve-popup" (click)="$event.stopPropagation()">
    <div class="approve-popup-header">
      <h2 class="approve-popup-title">Confirm Request Approval</h2>
    </div>
    <div class="approve-popup-body">
      <label class="approve-ack">
        <input type="checkbox" class="approve-ack-checkbox" [(ngModel)]="acknowledged" />
        <span class="approve-ack-text">
          I hereby acknowledge that I have thoroughly reviewed the
          <span class="approve-ack-request">{{ requestId }}: {{ requestType }}</span>
          request and am making an informed decision
        </span>
      </label>
    </div>
    <div class="approve-popup-footer">
      <button type="button" class="approve-popup-cancel" (click)="closeApproveModal()">Cancel</button>
      <button type="button" class="approve-popup-confirm" [disabled]="!acknowledged"
        (click)="confirmApprove()">Approve Request</button>
    </div>
  </div>
</div>
}

<!-- ─── Confirm Request Rejection Popup ─── -->
@if (showRejectModal) {
<div class="approve-popup-overlay" (click)="closeRejectModal()">
  <div class="approve-popup reject-popup" (click)="$event.stopPropagation()">
    <div class="approve-popup-header">
      <h2 class="approve-popup-title">Confirm Request Rejection</h2>
    </div>
    <div class="reject-popup-body">
      <p class="reject-popup-message">
        You are about to reject this Request
        <span class="reject-popup-request">{{ requestId }} : {{ requestType }}</span>
      </p>
      <div class="reject-reason-group">
        <label class="reject-reason-label">Reason for Rejection <span class="reject-reason-required">*</span></label>
        <textarea class="reject-reason-input" rows="4" [(ngModel)]="rejectionReason"
          placeholder="Enter reason for rejection"></textarea>
      </div>
    </div>
    <div class="reject-popup-footer">
      <button type="button" class="approve-popup-cancel" (click)="closeRejectModal()">Cancel</button>
      <button type="button" class="reject-popup-confirm" [disabled]="!rejectionReason.trim()"
        (click)="confirmReject()">Reject Request Notify User</button>
    </div>
  </div>
</div>
}
